var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinussfu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4229 16.7986C41.8 11.6286 27.3272 1.95485 27.3272 6.32028V11.396C24.7663 11.3675 22.2051 11.4041 19.646 11.506C18.9276 11.5229 18.2404 11.803 17.715 12.2932C17.1895 12.7833 16.8623 13.4494 16.7954 14.1649C16.6603 15.884 16.6603 17.5591 16.7954 19.2783C16.8623 19.9938 17.1895 20.6598 17.715 21.15C18.2404 21.6401 18.9276 21.9202 19.646 21.9371C21.1672 21.9958 22.6674 22.0325 24.1466 22.0471C24.9883 22.0513 25.7944 22.3873 26.3899 22.9822C26.9854 23.5771 27.3222 24.3828 27.3272 25.2246V27.1197C27.3272 31.3971 41.8472 21.7926 41.4229 16.7986Z",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58346 27.39C2.20946 22.2169 16.6792 12.5463 16.6792 16.9086V18.8069C16.6792 20.5543 18.1092 21.9655 19.8597 21.9812C21.339 21.9979 22.8392 22.0357 24.3603 22.0943C25.0785 22.1119 25.7653 22.3923 26.2907 22.8823C26.816 23.3723 27.1434 24.038 27.2109 24.7532C27.346 26.4723 27.346 28.1475 27.2109 29.8666C27.1441 30.5821 26.8169 31.2481 26.2914 31.7383C25.7659 32.2284 25.0787 32.5086 24.3603 32.5255C21.8013 32.6273 19.2401 32.664 16.6792 32.6355V37.7112C16.6792 41.9855 2.15918 32.384 2.58346 27.39Z",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinussfu);
export default __webpack_public_path__ + "static/media/minussfu.5fb83188c0eed7bf8a84d31671492436.svg";
export { ForwardRef as ReactComponent };